import { getRegexRulesForField } from "./fieldValidators";

export default function validateField(fieldName, value) {
    const errors = [];
    if (!fieldName || typeof fieldName !== "string") {
        return ["A " + fieldName + " is required"];
    }
    if (!value || typeof value !== "string") {
        return ["A " + value + " is required"];
    }

    const fieldRegExRules = getRegexRulesForField(fieldName);
    fieldRegExRules.forEach(([ruleName, ruleData]) => {
        try {
            const parsedRule = JSON.parse(ruleData.toString());
            const {regex, errorMessage} = parsedRule;
            if (!new RegExp(regex.toString()).test(value)) {
                errors.push(errorMessage);
            }
        } catch (e) {
            console.error(`Invalid regex or rule in "${ruleName}":`, e);
        }
    });

    return errors;
}